var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.meta.last_page,"total-visible":7,"color":"blue darken-1"},on:{"input":_vm.onPageChange},model:{value:(_vm.localCurrentPage),callback:function ($$v) {_vm.localCurrentPage=$$v},expression:"localCurrentPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }